import React from 'react';
import { EnvelopeSimple, Phone, User, Users } from '@phosphor-icons/react';
import type { OpportunitySalesPerson } from '../../../../@types/oneButtonType';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import DashboardModal from './DashboardModal';
import './oneButton-css/SalesPersonModal.css';

export interface SalesPersonModalProps {
    open: boolean;
    onClose: () => void;
    salesPerson: OpportunitySalesPerson | null | undefined;
}

const SalesPersonModal: React.FC<SalesPersonModalProps> = ({ open, onClose, salesPerson }) => {
    const theme = useOneButtonStore((s) => s.theme);
    const division = salesPerson?.Sales_Division?.trim() || '—';
    const name = salesPerson?.Name?.trim() || '—';
    const phone = salesPerson?.Phone?.trim() || '—';
    const email = salesPerson?.Email?.trim() || '—';
    const team = salesPerson?.Team?.trim();

    return (
        <DashboardModal
            open={open}
            onClose={onClose}
            title="Sales person"
            width={440}
            destroyOnClose
            theme={theme}
        >
            <div className="obd-sales-person-modal">
                <p className="obd-sales-person-modal__division-line">
                    <span className="obd-sales-person-modal__division-label">Sales Person:</span>
                    <span className="obd-sales-person-modal__division-value">{division}</span>
                </p>
                <ul className="obd-sales-person-modal__list" aria-label="Sales person contact details">
                    <li className="obd-sales-person-modal__row">
                        <span className="obd-sales-person-modal__icon-wrap" aria-hidden>
                            <User size={18} weight="bold" />
                        </span>
                        <span className="obd-sales-person-modal__text">{name}</span>
                    </li>
                    <li className="obd-sales-person-modal__row">
                        <span className="obd-sales-person-modal__icon-wrap" aria-hidden>
                            <Phone size={18} weight="bold" />
                        </span>
                        <span className="obd-sales-person-modal__text">{phone}</span>
                    </li>
                    <li className="obd-sales-person-modal__row">
                        <span className="obd-sales-person-modal__icon-wrap" aria-hidden>
                            <EnvelopeSimple size={18} weight="bold" />
                        </span>
                        <span className="obd-sales-person-modal__text">{email}</span>
                    </li>
                    {team ? (
                        <li className="obd-sales-person-modal__row obd-sales-person-modal__row--team">
                            <span className="obd-sales-person-modal__icon-wrap" aria-hidden>
                                <Users size={18} weight="bold" />
                            </span>
                            <span className="obd-sales-person-modal__text">{team}</span>
                        </li>
                    ) : null}
                </ul>
            </div>
        </DashboardModal>
    );
};

export default SalesPersonModal;
